import type { PropertyMatch } from '@cli-types/next-adapter/init.js'
import {
  createCodeScannerState,
  isIdentifierBoundary,
  isIdentifierStart
} from '@cli-utils/js-source-scan.js'
import { advanceTopLevelScanner } from './advance-top-level-scanner.js'
import { findTopLevelValueEnd } from './find-top-level-value-end.js'

export function findTopLevelProperty(
  content: string,
  objectStart: number,
  objectEnd: number,
  propertyName: string
): PropertyMatch | null {
  let depth = 0
  const scannerState = createCodeScannerState()

  for (let i = objectStart + 1; i < objectEnd; i++) {
    const scanResult = advanceTopLevelScanner(content, i, scannerState, depth)
    depth = scanResult.depth
    if (scanResult.skip) {
      i = scanResult.nextIndex
      continue
    }

    if (!isIdentifierStart(scanResult.char)) {
      continue
    }

    if (
      !content.startsWith(propertyName, i) ||
      !isIdentifierBoundary(content[i + propertyName.length])
    ) {
      continue
    }

    let cursor = i + propertyName.length
    while (cursor < objectEnd && /\s/.test(content[cursor]!)) cursor++
    if (content[cursor] !== ':') continue

    cursor++
    while (cursor < objectEnd && /\s/.test(content[cursor]!)) cursor++
    const valueStart = cursor
    const valueEnd = findTopLevelValueEnd(content, valueStart, objectEnd)

    return {
      propertyStart: i,
      value: content.slice(valueStart, valueEnd),
      valueStart,
      valueEnd
    }
  }

  return null
}
